import React from 'react';
import { motion } from 'framer-motion';
export function ModulesSection() {
  const modules = [{
    emoji: '📘',
    title: 'MÓDULO I: Intervención en Deterioro Cognitivo Leve',
    description: 'Para el paciente que empieza a olvidar pero todavía tiene conciencia de sus dificultades. 50 fichas técnicas organizadas por área cognitiva. Memoria · Atención · Lenguaje · Funciones Ejecutivas · Orientación · Razonamiento. Nivel de dificultad calibrado para el perfil DCL. Con instrucciones clínicas para el profesional en cada ficha.',
    color: 'from-blue-50 to-blue-100'
  }, {
    emoji: '📗',
    title: 'MÓDULO II: Intervención en Deterioro Cognitivo Moderado',
    description: 'Para el paciente con desorientación frecuente, lenguaje empobrecido y baja conciencia de sus dificultades. 50 fichas adaptadas al perfil moderado. Estímulos simples, consignas claras, actividades que generan éxito para sostener la motivación. Incluye estrategias para manejar la resistencia y la apatía en sesión.',
    color: 'from-green-50 to-green-100'
  }, {
    emoji: '📙',
    title: 'MÓDULO III: Envejecimiento Saludable y Prevención Cognitiva',
    description: 'Para el paciente de 60 a 90 años sin diagnóstico que quiere mantenerse activo mentalmente. 50 fichas de estimulación preventiva. El nivel más versátil del sistema. Funciona también como punto de entrada antes de saber en qué módulo ubicar al paciente nuevo.',
    color: 'from-orange-50 to-orange-100'
  }, {
    emoji: '📔',
    title: 'MÓDULO IV: Manual de Psicoeducación Familiar',
    description: 'Para que la familia sea tu aliada en el tratamiento y no un obstáculo. El recurso que le entregás a los hijos o cuidadores del paciente en la primera sesión. Explica por qué estimulamos, qué esperar del proceso y cómo acompañar en casa sin frustrar al adulto mayor. El profesional que lo entrega queda posicionado como un especialista que piensa en el sistema completo, no solo en la sesión.',
    color: 'from-amber-50 to-amber-100'
  }];
  return <section className="py-16 sm:py-24 bg-gray-50" data-id="element-155">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-157">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-158">
            QUÉ TE LLEVÁS HOY
          </h2>

          <p className="text-lg text-gray-600 mb-12 text-center max-w-3xl mx-auto" data-id="element-159">
            El sistema está organizado en dos grandes bloques: el núcleo clínico
            y las herramientas de gestión. Uno sin el otro no funciona. Juntos,
            transforman completamente tu práctica profesional.
          </p>

          <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8" data-id="element-160">
            LOS 4 MÓDULOS CLÍNICOS
          </h3>

          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-161">
            {modules.map((module, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} whileHover={{
            y: -5
          }} className={`bg-gradient-to-br ${module.color} p-6 rounded-lg shadow-md border border-gray-200 hover:shadow-xl transition-all duration-300`} data-id="element-162">
                <div className="text-5xl mb-4" data-id="element-163">{module.emoji}</div>
                <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-164">
                  {module.title}
                </h4>
                <p className="text-gray-700 leading-relaxed" data-id="element-165">
                  {module.description}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}